<template>

    <Transition name="modal-fade">
      <div v-if="isdisplay" class="cf-overlay" @click.self="close">
        <Transition name="modal-slide">
          <div v-if="isdisplay" class="cf-dialog cf-dialog--xxl">

                <!-- Header -->
                <div class="cf-modal-head cf-dialog-head">
                    <div class="cf-modal-head__main">
                        <span class="cf-modal-head__icon"><i class="ri-printer-line"></i></span>
                        <div>
                            <h4 class="cf-dialog-title">{{titlemodal}}</h4>
                            <p class="cf-modal-head__sub">Aperçu avant impression</p>
                        </div>
                    </div>
                    <button @click="close" type="button" class="cf-dialog-close" aria-label="Fermer"><i class="ri-close-line"></i></button>
                </div>

                <!-- Body -->
                <div class="cf-dialog-body">
                    <div class="box overflow-hidden">

                        <!-- BOX HEADER : titre + actions + toggle filtres -->
                        <div class="box-header justify-between flex-wrap gap-2">
                            <div class="box-title">{{titlemodal}}</div>
                            <div class="flex items-center gap-2 flex-wrap">
                                <button @click="print4" class="ti-btn ti-btn-success-full !py-1 !px-3 !text-xs">
                                    <i class="ri-printer-line mr-1"></i>Imprimer
                                </button>
                                <button @click="ExportExcel('xlsx',`${titlemodal} période (${datedebut} - ${datefin})`)"
                                        class="ti-btn ti-btn-info-full !py-1 !px-3 !text-xs">
                                    <i class="ri-file-excel-2-line mr-1"></i>Excel
                                </button>
                                <button @click="showFilters = !showFilters"
                                        class="ti-btn ti-btn-secondary-full !py-1 !px-3 !text-xs">
                                    <i class="ri-filter-3-line mr-1"></i>
                                    {{ showFilters ? 'Masquer les filtres' : 'Afficher les filtres' }}
                                    <i :class="showFilters ? 'ri-arrow-up-s-line' : 'ri-arrow-down-s-line'" class="ml-1"></i>
                                </button>
                            </div>
                        </div>

                        <div class="box-body !p-0">

                            <!-- BARRE STATS (toujours visible) -->
                            <div class="flex flex-wrap items-center gap-x-5 gap-y-1 px-4 py-2 bg-gray-50 border-b border-gray-200 text-sm">
                                <span class="text-gray-600">
                                    Lignes : <strong class="text-gray-800">{{ totalLignes }}</strong>
                                </span>
                                <span class="text-gray-600">
                                    Total : <strong class="text-blue-700">{{ formatMoney(currentTotal) }}</strong>
                                </span>
                                <span class="text-gray-600">
                                    Remise : <strong class="text-orange-600">{{ formatMoney(currentRemise) }}</strong>
                                </span>
                                <span class="text-gray-600">
                                    Restant : <strong class="text-red-600">{{ formatMoney(currentRestant) }}</strong>
                                </span>
                                <span class="text-gray-600">
                                    Annulées (BR) : <strong class="text-red-700">{{ formatMoney(montantAnnule) }}</strong>
                                </span>
                                <span v-if="brLinesCount > 0" class="ml-auto flex items-center gap-2 text-red-700 font-semibold text-xs">
                                    <span class="w-3 h-3 rounded-sm inline-block" style="background:#fee2e2;border:1px solid #f87171;"></span>
                                    {{ brLinesCount }} ligne(s) BR
                                </span>
                            </div>

                            <!-- ZONE FILTRES (collapsible) -->
                            <transition name="slide-filters">
                                <div v-show="showFilters" class="px-4 py-3 bg-white border-b border-gray-200">
                                    <div class="grid lg:grid-cols-4 md:grid-cols-2 grid-cols-1 gap-3">
                                        <div class="space-y-1">
                                            <label class="text-xs font-medium text-gray-600">Format impression</label>
                                            <select v-model="taillemodel" class="form-control form-control-sm w-full">
                                                <option value="A4">A4 Portrait</option>
                                                <option value="A4landscape">A4 Paysage</option>
                                                <option value="A5">A5 Portrait</option>
                                                <option value="A5landscape">A5 Paysage</option>
                                            </select>
                                        </div>
                                        <div class="space-y-1">
                                            <label class="text-xs font-medium text-gray-600">Date début</label>
                                            <input type="date" @change="refresh" v-model="datedebut" class="form-control form-control-sm w-full">
                                        </div>
                                        <div class="space-y-1">
                                            <label class="text-xs font-medium text-gray-600">Date fin</label>
                                            <input type="date" @change="refresh" v-model="datefin" class="form-control form-control-sm w-full">
                                        </div>
                                        <div class="space-y-1">
                                            <label class="text-xs font-medium text-gray-600">Mode d'affichage</label>
                                            <select class="form-control form-control-sm w-full" v-model="selectedaffichage">
                                                <option value="">Affichage simple</option>
                                                <option value="groupby">Groupé par client</option>
                                                <option value="groupbydate">Groupé par créé le</option>
                                            </select>
                                        </div>
                                    </div>
                                    <div class="grid lg:grid-cols-3 gap-3 mt-3">
                                        <input v-model="searchnomcaisse" type="text"
                                               class="form-control form-control-sm"
                                               placeholder="Rechercher une caisse...">
                                        <input v-model="searchbeneficiaire" type="text"
                                               class="form-control form-control-sm"
                                               placeholder="Rechercher un client...">
                                        <select class="form-control form-control-sm w-full" v-model="orderbycreerle">
                                            <option value="">Créé le - aucun tri</option>
                                            <option value="asc">Créé le - croissant ↑</option>
                                            <option value="desc">Créé le - décroissant ↓</option>
                                        </select>
                                    </div>
                                </div>
                            </transition>

                            <!-- ZONE TABLE -->
                            <div class="table-responsive tablearea">

                                <div ref="printdoc" class="my-5 page pagebreak">
                                    <div class="p-5">

                                        <section class="top-content mb-5 bb d-flex justify-content-between">
                                            <div class="logo">
                                                <img v-if="$store.state.etatlogo" :src="$store.state.etatlogo" alt="" style="width: 10%" class="img-fluid">
                                            </div>
                                        </section>

                                        <section class="mt-5">
                                            <div class="grid lg:grid-cols-2 gap-6 row">
                                                <div class="col-6">
                                                    <table class="table table-bordered">
                                                        <tbody>
                                                        <tr><td>Raison Social : {{$store.state.etatraisonsocial}}</td></tr>
                                                        <tr><td>Ifu : {{$store.state.etatifu}} / RC N° RCCM: {{$store.state.etatrccm}}</td></tr>
                                                        <tr><td>Téléphone : {{$store.state.etattelephone}} / {{$store.state.etatadresse}}</td></tr>
                                                        </tbody>
                                                    </table>
                                                </div>
                                                <div class="col-6">
                                                    <table class="table table-bordered w-full">
                                                        <tbody>
                                                        <tr>
                                                            <td style="text-align:center" colspan="2">{{soustitre}}</td>
                                                        </tr>
                                                        <tr>
                                                            <td v-if="viewperiode" style="text-align:center">PERIODE</td>
                                                            <td v-else style="text-align:center">JOURNEE DU</td>
                                                            <td style="text-align:center">IMPRIMER PAR</td>
                                                        </tr>
                                                        <tr>
                                                            <td v-if="viewperiode" style="text-align:center">{{datedebut+' - '+datefin}}</td>
                                                            <td v-else style="text-align:center">{{datejournee}}</td>
                                                            <td style="text-align:center">{{$store.state.appusername}}</td>
                                                        </tr>
                                                        <tr v-if="!viewperiode">
                                                            <td style="text-align:center" colspan="2">PERIODE {{datedebut+' - '+datefin}}</td>
                                                        </tr>
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                        </section>

                                        <section class="product-area mt-3">

                                            <!-- Légende BR (visible à l'écran, masquée à l'impression si souhaité) -->
                                            <div v-if="brLinesCount > 0" class="mb-2 flex items-center gap-2 text-xs text-red-700 no-print">
                                                <span class="w-3 h-3 rounded-sm inline-block" style="background:#fee2e2;border:1px solid #f87171;"></span>
                                                Les lignes surlignées en rouge sont des bons de retour (BR)
                                            </div>

                                            <!-- ═══════════════════════════════════════════════════
                                                 TABLE 1 - AFFICHAGE SIMPLE
                                                 ═══════════════════════════════════════════════════ -->
                                            <table ref="exportable_table"
                                                   v-if="selectedaffichage===''"
                                                   class="mb-3 table table-striped table-bordered table-hover dataTable no-footer dtr-inline mytable w-full">
                                                <thead>
                                                <tr>
                                                    <th>N°</th>
                                                    <th>Caisse</th>
                                                    <th>N°Document</th>
                                                    <th>Autre Document</th>
                                                    <th>Date</th>
                                                    <th>Client</th>
                                                    <th>Indication</th>
                                                    <th>Mode de règlement</th>
                                                    <th>Montant</th>
                                                    <th>Remise</th>
                                                    <th>Montant restant</th>
                                                    <th>Créé par</th>
                                                    <th>Créé le</th>
                                                    <th>Action</th>
                                                </tr>
                                                </thead>
                                                <tbody>
                                                <template v-if="filterdatatable.length">
                                                    <tr style="font-weight:600"
                                                        v-for="(datavalue,index) in filterdatatable" :key="index"
                                                        :class="isBRLine(datavalue) ? 'br-line' : ''">
                                                        <td data-label="N° :">{{ index+1 }}</td>
                                                        <td data-label="Caisse :">{{ datavalue.nomcaisse }}</td>
                                                        <td data-label="N°Document :">{{ datavalue.numdoc }}</td>
                                                        <td data-label="Autre Document :">
                                                            <span v-if="isPending(datavalue.numdoc)" class="text-orange-500">
                                                                <i class="ri-loader-4-line animate-spin"></i> En attente...
                                                            </span>
                                                            <span v-else>{{ datavalue.nbonother }}</span>
                                                        </td>
                                                        <td data-label="Date :">{{ datavalue.dateop }}</td>
                                                        <td data-label="Client :">{{ datavalue.client }}</td>
                                                        <td data-label="Indication :">{{ datavalue.indicateur }}</td>
                                                        <td data-label="Mode de règlement :">{{ datavalue.modereglement }}</td>
                                                        <td data-label="Montant :">{{ formatMoney(datavalue.mtntttc) }}</td>
                                                        <td data-label="Remise :">{{ formatMoney(datavalue.mtntremise) }}</td>
                                                        <td data-label="Montant restant :">{{ formatMoney(datavalue.mtntttctrt) }}</td>
                                                        <td data-label="Créé par :">{{ datavalue.saisir_par }}</td>
                                                        <td data-label="Créé le :">{{ datavalue.creer_le }}</td>
                                                        <td data-label="Action :">
                                                            <div class="cf-actions">
                                                                <button v-if="datavalue.normalise==='0' || datavalue.normalise===0" @click="btnnormalisationdelafacture(datavalue)" class="cf-iconbtn cf-iconbtn--primary" title="Normaliser"><i class="ri-exchange-fill"></i></button>
                                                                <button @click="printline(datavalue)" class="cf-iconbtn cf-iconbtn--success" title="Imprimer"><i class="ri-printer-fill"></i></button>
                                                                <button v-if="datavalue.nbonother===''" @click="btnannulation(datavalue)" class="cf-iconbtn cf-iconbtn--danger" title="Annuler la facture"><i class="ri-close-circle-line"></i></button>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                </template>
                                                <template v-else>
                                                    <tr>
                                                        <td colspan="14"><div class="alert alert-danger">Aucune donnée trouvée</div></td>
                                                    </tr>
                                                </template>
                                                </tbody>
                                                <tfoot>
                                                <tr class="tfoot-total">
                                                    <td colspan="8" data-label="TOTAL :">
                                                        <strong>TOTAL</strong>
                                                    </td>
                                                    <td data-label="Montant :"><strong>{{formatMoney(montanttolal)}}</strong></td>
                                                    <td data-label="Remise :"><strong>{{formatMoney(montanttolalremise)}}</strong></td>
                                                    <td data-label="Montant restant :"><strong>{{formatMoney(montanttolalrestant)}}</strong></td>
                                                    <td colspan="3"></td>
                                                </tr>
                                                </tfoot>
                                            </table>

                                            <!-- ═══════════════════════════════════════════════════
                                                 TABLE 2 - GROUPÉ PAR CLIENT
                                                 ═══════════════════════════════════════════════════ -->
                                            <table ref="exportable_table"
                                                   v-if="selectedaffichage==='groupby'"
                                                   class="table table-striped table-bordered table-hover dataTable no-footer dtr-inline mytable w-full">
                                                <thead>
                                                <tr>
                                                    <th>N°</th>
                                                    <th>Caisse</th>
                                                    <th>N°Document</th>
                                                    <th>Autre Document</th>
                                                    <th>Date</th>
                                                    <th>Indication</th>
                                                    <th>Mode de règlement</th>
                                                    <th>Montant</th>
                                                    <th>Remise</th>
                                                    <th>Montant restant</th>
                                                    <th>Créé par</th>
                                                    <th>Créé le</th>
                                                </tr>
                                                </thead>
                                                <tbody>
                                                <template v-if="Object.keys(filterdatatable).length">
                                                    <template v-for="(myvalue,index) in filterdatatable" :key="index">

                                                        <!-- En-tête groupe client -->
                                                        <tr class="group-header-row">
                                                            <td colspan="12">
                                                                <span class="font-bold">Client : {{ myvalue[0].client }}</span>
                                                                <span class="ml-3 text-xs font-normal opacity-75">({{ myvalue.length }} transaction(s))</span>
                                                            </td>
                                                        </tr>

                                                        <!-- Lignes détail -->
                                                        <tr style="font-weight:600"
                                                            v-for="(datavalue,i) in myvalue" :key="i"
                                                            :class="isBRLine(datavalue) ? 'br-line' : ''">
                                                            <td data-label="N° :">{{ i+1 }}</td>
                                                            <td data-label="Caisse :">{{ datavalue.nomcaisse }}</td>
                                                            <td data-label="N°Document :">{{ datavalue.numdoc }}</td>
                                                            <td data-label="Autre Document :">
                                                                <span v-if="isPending(datavalue.numdoc)" class="text-orange-500">
                                                                    <i class="ri-loader-4-line animate-spin"></i> En attente...
                                                                </span>
                                                                <span v-else>{{ datavalue.nbonother }}</span>
                                                            </td>
                                                            <td data-label="Date :">{{ datavalue.dateop }}</td>
                                                            <td data-label="Indication :">{{ datavalue.indicateur }}</td>
                                                            <td data-label="Mode de règlement :">{{ datavalue.modereglement }}</td>
                                                            <td data-label="Montant :">{{ formatMoney(datavalue.mtntttc) }}</td>
                                                            <td data-label="Remise :">{{ formatMoney(datavalue.mtntremise) }}</td>
                                                            <td data-label="Montant restant :">{{ formatMoney(datavalue.mtntttctrt) }}</td>
                                                            <td data-label="Créé par :">{{ datavalue.saisir_par }}</td>
                                                            <td data-label="Créé le :">{{ datavalue.creer_le }}</td>
                                                        </tr>

                                                        <!-- Sous-total groupe client -->
                                                        <tr class="group-total-row">
                                                            <td colspan="7" class="text-right">
                                                                <strong>Sous-total : {{ myvalue[0].client }}</strong>
                                                            </td>
                                                            <td><strong>{{formatMoney(myvalue[0].montanttolal)}}</strong></td>
                                                            <td><strong>{{formatMoney(myvalue[0].montanttolalremise)}}</strong></td>
                                                            <td><strong>{{formatMoney(myvalue[0].montanttolalrestant)}}</strong></td>
                                                            <td colspan="2"></td>
                                                        </tr>

                                                    </template>
                                                </template>
                                                <template v-else>
                                                    <tr>
                                                        <td colspan="12"><div class="alert alert-danger">Aucune donnée trouvée</div></td>
                                                    </tr>
                                                </template>
                                                </tbody>
                                                <tfoot>
                                                <tr class="tfoot-total">
                                                    <td colspan="7"><strong>TOTAL GÉNÉRAL</strong></td>
                                                    <td><strong>{{formatMoney(montanttolalgroupby)}}</strong></td>
                                                    <td><strong>{{formatMoney(montanttolalgroupbyremise)}}</strong></td>
                                                    <td><strong>{{formatMoney(montanttolalgroupbyrestant)}}</strong></td>
                                                    <td colspan="2"></td>
                                                </tr>
                                                </tfoot>
                                            </table>

                                            <!-- ═══════════════════════════════════════════════════
                                                 TABLE 3 - GROUPÉ PAR CRÉÉ LE (NOUVEAU)
                                                 ═══════════════════════════════════════════════════ -->
                                            <table ref="exportable_table"
                                                   v-if="selectedaffichage==='groupbydate'"
                                                   class="table table-striped table-bordered table-hover dataTable no-footer dtr-inline mytable w-full">
                                                <thead>
                                                <tr>
                                                    <th>N°</th>
                                                    <th>Caisse</th>
                                                    <th>N°Document</th>
                                                    <th>Autre Document</th>
                                                    <th>Date op.</th>
                                                    <th>Client</th>
                                                    <th>Indication</th>
                                                    <th>Mode de règlement</th>
                                                    <th>Montant</th>
                                                    <th>Remise</th>
                                                    <th>Montant restant</th>
                                                    <th>Créé par</th>
                                                </tr>
                                                </thead>
                                                <tbody>
                                                <template v-if="Object.keys(filterdatatable).length">
                                                    <template v-for="(myvalue,index) in filterdatatable" :key="index">

                                                        <!-- En-tête groupe date -->
                                                        <tr class="group-header-row">
                                                            <td colspan="12">
                                                                <span class="font-bold">Créé le : {{ index }}</span>
                                                                <span class="ml-3 text-xs font-normal opacity-75">({{ myvalue.length }} transaction(s))</span>
                                                            </td>
                                                        </tr>

                                                        <!-- Lignes détail -->
                                                        <tr style="font-weight:600"
                                                            v-for="(datavalue,i) in myvalue" :key="i"
                                                            :class="isBRLine(datavalue) ? 'br-line' : ''">
                                                            <td data-label="N° :">{{ i+1 }}</td>
                                                            <td data-label="Caisse :">{{ datavalue.nomcaisse }}</td>
                                                            <td data-label="N°Document :">{{ datavalue.numdoc }}</td>
                                                            <td data-label="Autre Document :">
                                                                <span v-if="isPending(datavalue.numdoc)" class="text-orange-500">
                                                                    <i class="ri-loader-4-line animate-spin"></i> En attente...
                                                                </span>
                                                                <span v-else>{{ datavalue.nbonother }}</span>
                                                            </td>
                                                            <td data-label="Date op. :">{{ datavalue.dateop }}</td>
                                                            <td data-label="Client :">{{ datavalue.client }}</td>
                                                            <td data-label="Indication :">{{ datavalue.indicateur }}</td>
                                                            <td data-label="Mode de règlement :">{{ datavalue.modereglement }}</td>
                                                            <td data-label="Montant :">{{ formatMoney(datavalue.mtntttc) }}</td>
                                                            <td data-label="Remise :">{{ formatMoney(datavalue.mtntremise) }}</td>
                                                            <td data-label="Montant restant :">{{ formatMoney(datavalue.mtntttctrt) }}</td>
                                                            <td data-label="Créé par :">{{ datavalue.saisir_par }}</td>
                                                        </tr>

                                                        <!-- Sous-total groupe date -->
                                                        <tr class="group-total-row">
                                                            <td colspan="8" class="text-right">
                                                                <strong>Sous-total du {{ index }}</strong>
                                                            </td>
                                                            <td><strong>{{formatMoney(myvalue[0].montanttolal)}}</strong></td>
                                                            <td><strong>{{formatMoney(myvalue[0].montanttolalremise)}}</strong></td>
                                                            <td><strong>{{formatMoney(myvalue[0].montanttolalrestant)}}</strong></td>
                                                            <td></td>
                                                        </tr>

                                                    </template>
                                                </template>
                                                <template v-else>
                                                    <tr>
                                                        <td colspan="12"><div class="alert alert-danger">Aucune donnée trouvée</div></td>
                                                    </tr>
                                                </template>
                                                </tbody>
                                                <tfoot>
                                                <tr class="tfoot-total">
                                                    <td colspan="8"><strong>TOTAL GÉNÉRAL</strong></td>
                                                    <td><strong>{{formatMoney(montanttolalgroupbydate)}}</strong></td>
                                                    <td><strong>{{formatMoney(montanttolalgroupbydateremise)}}</strong></td>
                                                    <td><strong>{{formatMoney(montanttolalgroupbydaterestant)}}</strong></td>
                                                    <td></td>
                                                </tr>
                                                </tfoot>
                                            </table>

                                        </section>

                                        <section class="balance-info mt-3">
                                            <div class="grid grid-cols-2 gap-x-6 mt-3 row">
                                                <div class="col-6"></div>
                                                <div class="col-6"></div>
                                            </div>
                                        </section>

                                    </div>
                                </div>

                            </div>

                        </div>
                    </div>
                </div>

                <!-- Footer -->
                <div class="cf-dialog-foot">
                    <button @click="print4" type="button" class="ti-btn ti-btn-primary-full"><i class="ri-printer-line align-middle"></i> Imprimer</button>
                    <button @click="close" type="button" class="ti-btn ti-btn-secondary-full">Fermer</button>
                </div>

          </div>
        </Transition>
      </div>
    </Transition>

    <modalfacturecomptoirepost ref="modalfacturecomptoirepost"></modalfacturecomptoirepost>
    <annullationdefacture ref="annullationdefacture" @closed="onAnnulationClosed"></annullationdefacture>
    <normalisationdelafacture ref="normalisationdelafacture" @closed="refresh"></normalisationdelafacture>

</template>

<script>
    import {
        currencyFormatDE, currencyFormatMonney,
        currentDate, currentDateTime,
        ExportExcel, FormatNumber,
        getYear, groupByKey,
        impression, isValidDateString, NumbertoLettre,
        randomString
    } from "@/allfunction";
    import * as JwtService from "@/common/jwt.service";
    import qrcode from 'qrcode.vue'
    import modalfacturecomptoirepost from "@/components/views/pages/caisse/rapport/modal_facturecomptoirepost";
    import annullationdefacture from "@/components/views/pages/caisse/rapport/annullationdefacture";
    import normalisationdelafacture from "@/components/views/pages/caisse/rapport/normalisationdelafacture";
    import qrcodetoimage from "qrcode";

    const axios = require('axios');

    export default {
        /* eslint-disable */
        name: "modal_listedesfacturactionsalacaissev2",

        watch: {
            searchword(newvalue) { this.page = 1 },
            searchtrierletableau(newvalue) { this.page = 1 }
        },

        computed: {

            soustitre() {
                this.taillemodel = 'A4';
                return this.titlemodal;
            },

            viewall() {
                return this.mmois === "" || this.manne === "";
            },

            displayedPages() {
                const start = Math.max(1, this.page - 5);
                const end = Math.min(this.pages.length, start + 9);
                let result = [];
                if (start > 1) { result.push(1); if (start > 2) result.push('...'); }
                for (let i = start; i <= end; i++) result.push(i);
                if (end < this.pages.length) {
                    if (end < this.pages.length - 1) result.push('...');
                    result.push(this.pages.length);
                }
                return result;
            },

            // ─── Stats réactives ────────────────────────────────────────────────
            totalLignes() {
                if (this.selectedaffichage === '') {
                    return Array.isArray(this.filterdatatable) ? this.filterdatatable.length : 0;
                }
                let total = 0;
                for (const key in this.filterdatatable) {
                    if (Array.isArray(this.filterdatatable[key])) total += this.filterdatatable[key].length;
                }
                return total;
            },

            montanttolal() {
                return this.filteredFlat.reduce((sum, item) => sum + (parseFloat(item.mtntttc) || 0), 0);
            },

            montanttolalremise() {
                return this.filteredFlat.reduce((sum, item) => sum + (parseFloat(item.mtntremise) || 0), 0);
            },

            montanttolalrestant() {
                return this.filteredFlat.reduce((sum, item) => sum + (parseFloat(item.mtntttctrt) || 0), 0);
            },

            currentTotal()   { return this.montanttolal; },
            currentRemise()  { return this.montanttolalremise; },
            currentRestant() { return this.montanttolalrestant; },

            filteredFlat() {
                let mvalue = this.datatable;
                if (this.searchnomcaisse !== '') {
                    const s = this.searchnomcaisse.toLowerCase();
                    mvalue = mvalue.filter(p => p.nomcaisse.toLowerCase().includes(s));
                }
                if (this.searchbeneficiaire !== '') {
                    const s = this.searchbeneficiaire.toLowerCase();
                    mvalue = mvalue.filter(p => p.client.toLowerCase().includes(s));
                }
                return mvalue;
            },

            brLinesCount() {
                return this.filteredFlat.filter(row => this.isBRLine(row)).length;
            },

            montantAnnule() {
                return this.filteredFlat
                    .filter(row => this.isBRLine(row))
                    .reduce((sum, row) => sum + (parseFloat(row.mtntttc) || 0), 0);
            },

            // ─── Données filtrées / groupées ────────────────────────────────────
            filterdatatable() {
                let mvalue = this.datatable, $dataretun = [];

                this.perPage = this.DefaultperPage;

                if (this.searchnomcaisse !== '') {
                    const s = this.searchnomcaisse.toLowerCase();
                    mvalue = mvalue.filter(post => post.nomcaisse.toLowerCase().includes(s));
                }

                if (this.searchbeneficiaire !== '') {
                    const s = this.searchbeneficiaire.toLowerCase();
                    mvalue = mvalue.filter(post => post.client.toLowerCase().includes(s));
                }

                // ── TRI PAR CRÉÉ LE ─────────────────────────────────────────────
                if (this.orderbycreerle === 'asc') {
                    mvalue = mvalue.slice().sort((a, b) => (a.creer_le || '') > (b.creer_le || '') ? 1 : -1);
                } else if (this.orderbycreerle === 'desc') {
                    mvalue = mvalue.slice().sort((a, b) => (a.creer_le || '') < (b.creer_le || '') ? 1 : -1);
                }

                // ── MODE SIMPLE ──────────────────────────────────────────────────
                if (this.selectedaffichage === '') {
                    $dataretun = mvalue;

                // ── MODE GROUPÉ PAR CLIENT ───────────────────────────────────────
                } else if (this.selectedaffichage === 'groupby') {
                    this.montanttolalgroupby = 0;
                    this.montanttolalgroupbyremise = 0;
                    this.montanttolalgroupbyrestant = 0;

                    mvalue.forEach(item => {
                        this.montanttolalgroupby      += parseFloat(item.mtntttc)    || 0;
                        this.montanttolalgroupbyrestant += parseFloat(item.mtntttctrt) || 0;
                        this.montanttolalgroupbyremise  += parseFloat(item.mtntremise)  || 0;
                    });

                    let $datagroupby = groupByKey(mvalue, 'client');

                    for (let [, $line] of Object.entries($datagroupby)) {
                        let montanttolal = 0, montanttolalremise = 0, montanttolalrestant = 0;
                        $line.forEach(item => {
                            montanttolal       += parseFloat(item.mtntttc)    || 0;
                            montanttolalremise  += parseFloat(item.mtntremise)  || 0;
                            montanttolalrestant += parseFloat(item.mtntttctrt) || 0;
                        });
                        $line.forEach(item => {
                            item.montanttolal       = montanttolal;
                            item.montanttolalremise  = montanttolalremise;
                            item.montanttolalrestant = montanttolalrestant;
                        });
                    }

                    $dataretun = $datagroupby;

                // ── MODE GROUPÉ PAR CRÉÉ LE (NOUVEAU) ───────────────────────────
                } else if (this.selectedaffichage === 'groupbydate') {
                    this.montanttolalgroupbydate = 0;
                    this.montanttolalgroupbydateremise = 0;
                    this.montanttolalgroupbydaterestant = 0;

                    mvalue.forEach(item => {
                        this.montanttolalgroupbydate      += parseFloat(item.mtntttc)    || 0;
                        this.montanttolalgroupbydaterestant += parseFloat(item.mtntttctrt) || 0;
                        this.montanttolalgroupbydateremise  += parseFloat(item.mtntremise)  || 0;
                    });

                    const mvalueWithDateKey = mvalue.map(item => ({
                        ...item,
                        creer_le_dateonly: item.creer_le ? item.creer_le.split(' ')[0].split('T')[0] : ''
                    }));
                    let $datagroupby = groupByKey(mvalueWithDateKey, 'creer_le_dateonly');

                    for (let [, $line] of Object.entries($datagroupby)) {
                        let montanttolal = 0, montanttolalremise = 0, montanttolalrestant = 0;
                        $line.forEach(item => {
                            montanttolal       += parseFloat(item.mtntttc)    || 0;
                            montanttolalremise  += parseFloat(item.mtntremise)  || 0;
                            montanttolalrestant += parseFloat(item.mtntttctrt) || 0;
                        });
                        $line.forEach(item => {
                            item.montanttolal       = montanttolal;
                            item.montanttolalremise  = montanttolalremise;
                            item.montanttolalrestant = montanttolalrestant;
                        });
                    }

                    $dataretun = $datagroupby;
                }

                return $dataretun;
            }

        },

        components: {
            modalfacturecomptoirepost,
            annullationdefacture,
            normalisationdelafacture,
            qrcode
        },

        data() {
            return {
                mfontsize: 10,
                taillemodel: 'A4',
                mgetyear: getYear(),
                datenow: currentDate(),
                isdisplay: false,
                viewperiode: false,
                showFilters: true,
                titlemodal: "",
                datatable: [],
                viewdrop: false,
                tabvalue: {},
                selectedaffichage: '',
                datejournee: "",
                datedebut: "",
                numpidcaisse: "",
                datefin: "",
                searchnomcaisse: "",
                searchbeneficiaire: "",
                typedoc: "",

                montanttolalgroupby: 0,
                montanttolalgroupbyremise: 0,
                montanttolalgroupbyrestant: 0,

                montanttolalgroupbydate: 0,
                montanttolalgroupbydateremise: 0,
                montanttolalgroupbydaterestant: 0,

                pendingVerifications: [],
                verificationTimer: null,
                lastCancelledDoc: null,
                orderbycreerle: '',

                posts: [''],
                page: 1,
                perPage: 1,
                Defaultpage: 1,
                DefaultperPage: 1,
                pages: [],

                textToEncode: '',
                size: 100,
                level: 'L'
            };
        },

        methods: {

            // ─── Détection ligne BR ─────────────────────────────────────────────
            isBRLine(datavalue) {
                if (!datavalue) return false;
                const indicateur = (datavalue.indicateur || '').toUpperCase();
                const numdoc     = (datavalue.numdoc     || '').toUpperCase();
                return indicateur.includes('BR') || numdoc.startsWith('BR');
            },

            // ─── Actions ────────────────────────────────────────────────────────
            btnnormalisationdelafacture(value) {
                this.$refs.normalisationdelafacture.show(value);
            },

            btnannulation(value) {
                this.lastCancelledDoc = value.numdoc;
                this.$refs.annullationdefacture.show(value);
            },

            formatMonney(value) { return currencyFormatMonney(value); },
            numbertolettre(chiffre) { return NumbertoLettre(chiffre); },

            btnviewdrop() {
                this.viewdrop = !this.viewdrop;
            },

            ExportExcel(type, name, fn, dl) {
                name = name + "_" + currentDateTime();
                var elt = this.$refs.exportable_table;
                ExportExcel(type, name, fn, dl, elt);
            },

            async print4() {
                const baseUrl = process.env.VUE_APP_URL || '';
                //let $style = [baseUrl +"/assets/css/style.css"];
                let $style = [];

                 if (this.taillemodel === "A4landscape" || this.taillemodel === "A5landscape") {
                    $style = [
                        baseUrl + 'print/bootstrap.min.css',
                        baseUrl + 'print/stylelandscape1.css',
                        baseUrl + 'print/stylelandscape.css'
                    ];
                } else {
                    $style = [
                        baseUrl + 'print/bootstrap.min.css',
                        baseUrl + 'print/styleportrait.css'
                    ];
                }

                //const scripts = ["https://cdn.tailwindcss.com"];
               // const scripts = [ baseUrl +"print/tailwindcss3.4.17"];
                const scripts = [];



                setTimeout(() => {
                  const printContent = this.$refs.printdoc.innerHTML;
                    impression(printContent,$style,window.document.title,scripts,{ format: this.taillemodel });
                }, 500);
            },

            formatMoney(value) { return currencyFormatDE(value); },
            formatnumber(value) { return FormatNumber(value); },

            returnFloatconvert(value) {
                return parseFloat(value).toFixed(4);
            },

            close() {
                if (this.verificationTimer) {
                    clearTimeout(this.verificationTimer);
                    this.verificationTimer = null;
                }
                this.isdisplay = false;
                this.$emit('closed');
            },

            selected(datavalue) {
                const elementSelectionne = { typ: this.typedoc, value: datavalue };
                this.$emit('elementSelectionne', elementSelectionne);
                this.isdisplay = false;
            },

            calculSomme(p1, p2, p3) {
                return currencyFormatDE(parseFloat(p1) + parseFloat(p2) + parseFloat(p3));
            },

            calculMonnaie(p1, p2) {
                return currencyFormatDE(parseFloat(p2) - parseFloat(p1));
            },

            currencyFormatDE(p1) {
                return currencyFormatDE(Number(p1));
            },

            async printline(value) {
                this.$store.dispatch('lancerchargement', true);
                const t = this;
                let url = process.env.VUE_APP_API_URL + '/egl74587kjkjrfdkcaisse771714dfe/comptoire/caisse/' + value.pid + '/' + this.$store.state.appsociete + '/allline895418init51comptoirerefdepdpcc11515/' + randomString(280);
                let response = axios.get(url, {
                    headers: {
                        'X-Requested-With': 'XMLHttpRequest',
                        'Accept': 'application/json',
                        'Content-Type': 'application/json',
                        'Authorization': 'Bearer ' + JwtService.getToken(),
                        'csrftoken': this.$store.state.appsociete
                    },
                    withCredentials: true
                });

                await response
                    .then(async function (res) {
                        t.$store.dispatch('lancerchargement', false);
                        if (res.data.success) {
                            let listedatatable = res.data.m;
                            let normalise       = value.normalise;
                            let mecefsignature  = value.mecefsignature;
                            let mecefnim        = value.mecefnim;
                            let mecefcompteur   = value.mecefcompteur;
                            let mecefheure      = value.mecefheure;
                            let mecefqrr        = value.mecefqrr;
                            let urlimagegenerer = "";

                            if (parseFloat(value.normalise) === 1) {
                                urlimagegenerer = await new Promise((resolve) => {
                                    qrcodetoimage.toDataURL(mecefqrr, { width: 125, margin: 2 }, (err, url) => resolve(err ? "" : url));
                                });
                            }

                            let items = [];
                            listedatatable.forEach(line => { if (line.etatline !== 2) items.push(line); });

                            let tabvalue = {
                                numdoc: value.numdoc,
                                date: value.dateop,
                                client: value.jsonv.client,
                                ifu: value.jsonv.ifu,
                                params: '',
                                params4: '',
                                boutique: '',
                                serveur: '',
                                commandetable: '',
                                vendeur: value.saisir_par,
                                items: items,
                                montantht: t.calculSomme(value.montantht, 0, 0),
                                montanttva: 0,
                                montantremise: t.currencyFormatDE(value.mtntremise),
                                montantnetapayer: t.currencyFormatDE(value.montantnetapayer),
                                reglement: t.currencyFormatDE(parseFloat(value.montantrecu)),
                                montantmonnaie: t.calculMonnaie(value.montantnetapayer, parseFloat(value.montantrecu)),
                                pourcentageprisenecharge: 0,
                                docsaisiepar: value.saisir_par,
                                normalise, mecefsignature, mecefnim, mecefcompteur, mecefheure,
                                mecefqrr: urlimagegenerer
                            };

                            if (value.jsonv && value.jsonv.param) tabvalue.params = value.jsonv.param.name;
                            t.$refs.modalfacturecomptoirepost.show(tabvalue, 'facture');
                        }
                    })
                    .catch(() => { t.$store.dispatch('lancerchargement', false); })
                    .finally(() => { t.$store.dispatch('lancerchargement', false); });
            },

            checkZero(i) {
                return i < 10 ? "0" + i : i;
            },

            async show(titlemodal, numpidcaisse, datedouverture, typedoc) {
                this.titlemodal = titlemodal;
                this.typedoc    = typedoc;

                if (datedouverture !== "") {
                    this.viewperiode  = false;
                    this.datejournee  = datedouverture;
                    this.datedebut    = datedouverture;
                    this.datefin      = datedouverture;
                    this.numpidcaisse = numpidcaisse;
                    this.refresh();
                } else {
                    this.viewperiode  = true;
                    this.datedebut    = currentDate();
                    this.datefin      = currentDate();
                    this.numpidcaisse = numpidcaisse;
                }

                this.isdisplay = true;
            },

            async refresh() {
                if (!isValidDateString(this.datedebut) || !isValidDateString(this.datefin)) return;

                this.$store.dispatch('lancerchargement', true);
                const t = this;
                let url = process.env.VUE_APP_API_URL + '/egl74587kjkjrfdkcaisse771714dfe/c/rapport/etatc/FVC/' + this.datedebut + '/' + this.datefin + '/' + this.numpidcaisse + '/' + this.$store.state.appsociete + '/8954fddpap18rapportcaisse519151911515/' + randomString();
                let response = axios.get(url, {
                    headers: {
                        'X-Requested-With': 'XMLHttpRequest',
                        'Accept': 'application/json',
                        'Content-Type': 'application/json',
                        'Authorization': 'Bearer ' + JwtService.getToken(),
                        'csrftoken': this.$store.state.appsociete
                    },
                    withCredentials: true
                });

                await response
                    .then(function (res) {
                        t.$store.dispatch('lancerchargement', false);
                        t.datatable = [];
                        if (res.data.success) {
                            t.datatable = res.data.m;
                        }
                    })
                    .catch(() => { t.$store.dispatch('lancerchargement', false); })
                    .finally(() => { t.$store.dispatch('lancerchargement', false); });
            },

            isPending(numdoc) {
                return this.pendingVerifications.some(p => p.numdoc === numdoc);
            },

            async onAnnulationClosed() {
                if (!this.lastCancelledDoc) { this.refresh(); return; }
                const numdoc = this.lastCancelledDoc;
                this.lastCancelledDoc = null;
                await this.refresh();
                const found = this.datatable.some(row =>
                    (row.nbonother || '').trim() === numdoc.trim() &&
                    parseFloat(row.mtntttc || 0) < 0
                );
                if (found) {
                    toastr['success']('Annulation du document ' + numdoc + ' confirmée.', '<b>Succès</b>');
                    return;
                }
                if (!this.pendingVerifications.find(p => p.numdoc === numdoc)) {
                    this.pendingVerifications.push({ numdoc: numdoc, attempts: 0 });
                }
                this.scheduleVerification();
            },

            scheduleVerification() {
                if (this.verificationTimer !== null) return;
                this.verificationTimer = setTimeout(async () => {
                    this.verificationTimer = null;
                    if (!this.isdisplay) return;
                    await this.refresh();
                    this.checkPendingVerifications();
                }, 5000);
            },

            async checkPendingVerifications() {
                if (this.pendingVerifications.length === 0) return;
                const remaining = [];
                for (const item of this.pendingVerifications) {
                    const found = this.datatable.some(row =>
                        (row.nbonother || '').trim() === item.numdoc.trim() &&
                        parseFloat(row.mtntttc || 0) < 0
                    );
                    if (found) {
                        toastr['success']('Annulation du document ' + item.numdoc + ' confirmée.', '<b>Succès</b>');
                    } else {
                        item.attempts++;
                        if (item.attempts < 3) {
                            remaining.push(item);
                        } else {
                            toastr['warning']('Vérification du document ' + item.numdoc + ' impossible. Veuillez actualiser manuellement.', '<b>Attention</b>');
                        }
                    }
                }
                this.pendingVerifications = remaining;
                if (this.pendingVerifications.length > 0) {
                    this.scheduleVerification();
                }
            },

            setPages(posts) {
                this.pages = [];
                let numberOfPages = Math.ceil(posts.length / this.perPage);
                for (let index = 1; index <= numberOfPages; index++) this.pages.push(index);
            },

            paginate(posts) {
                this.setPages(posts);
                let from = (this.page * this.perPage) - this.perPage;
                let to   = this.page * this.perPage;
                let $res = posts.slice(from, to);
                return $res.length > 0 ? $res : posts;
            }
        },

        beforeUnmount() {
            if (this.verificationTimer) {
                clearTimeout(this.verificationTimer);
                this.verificationTimer = null;
            }
        },

        mounted() {}
    }
</script>

<style scoped>
/* Charte cf-/ds- : tokens uniquement (light-only) */
.cf-overlay { position:fixed; inset:0; z-index:1000; display:flex; align-items:center; justify-content:center; padding:1rem; background:rgb(15 23 42 / 0.45); }
.cf-dialog { width:100%; background:#fff; border-radius:var(--cf-radius); box-shadow:var(--cf-shadow-md); display:flex; flex-direction:column; max-height:92vh; overflow:hidden; }
.cf-dialog--xxl { max-width:1200px; }
.cf-dialog-head { display:flex; align-items:center; justify-content:space-between; padding:1rem 1.25rem; border-bottom:1px solid var(--cf-border); flex-shrink:0; }
.cf-dialog-title { margin:0; font-size:0.95rem; font-weight:700; color:var(--cf-ink-strong); }
.cf-dialog-close { height:2rem; width:2rem; flex-shrink:0; display:inline-flex; align-items:center; justify-content:center; border-radius:var(--cf-radius-sm); border:none; background:var(--cf-surface-alt); color:var(--cf-muted); cursor:pointer; transition:all .15s; }
.cf-dialog-close:hover { background:#fee2e2; color:rgb(var(--danger)); }
.cf-dialog-body { padding:1.1rem 1.25rem; overflow-y:auto; flex:1; }
.cf-dialog-foot { display:flex; align-items:center; justify-content:flex-end; gap:0.6rem; padding:0.9rem 1.25rem; border-top:1px solid var(--cf-border); background:var(--cf-surface); flex-shrink:0; }

.modal-fade-enter-active, .modal-fade-leave-active { transition:opacity 0.25s ease; }
.modal-fade-enter-from, .modal-fade-leave-to { opacity:0; }
.modal-slide-enter-active, .modal-slide-leave-active { transition:all 0.25s ease; }
.modal-slide-enter-from, .modal-slide-leave-to { opacity:0; transform:translateY(-16px); }

    .table td { cursor: pointer; }

    /* Zone table scrollable */
    .tablearea {
        max-height: 520px;
        overflow-y: auto;
    }

    /* Lignes BR - bons de retour */
    .br-line {
        background-color: #fee2e2 !important;
    }
    .br-line td {
        color: #991b1b !important;
    }

    /* En-tête de groupe */
    .group-header-row td {
        background-color: #eff6ff !important;
        color: #1e40af !important;
        font-weight: 700;
        border-left: 4px solid #3b82f6;
        padding: 10px 12px;
    }

    /* Ligne sous-total de groupe */
    .group-total-row td {
        background-color: #f0fdf4 !important;
        color: #166534 !important;
        font-weight: 700;
        border-top: 2px solid #86efac;
    }

    /* Ligne total général (tfoot) */
    .tfoot-total td {
        background-color: #1e3a5f !important;
        color: #ffffff !important;
        font-weight: 700;
        font-size: 0.95rem;
    }

    /* Transition filtre */
    .slide-filters-enter-active,
    .slide-filters-leave-active {
        transition: max-height 0.25s ease, opacity 0.2s ease;
        overflow: hidden;
        max-height: 300px;
    }
    .slide-filters-enter-from,
    .slide-filters-leave-to {
        max-height: 0;
        opacity: 0;
    }

    .h-screen { height: 300px!important; }
    .mybodyheight200px { height: 200px; }
    .mybodyheight300px { height: 300px; }
    .mybodyheight400px { height: 400px; }
    .mybodyheight500px { height: 500px; }

    @media screen and (max-width: 768px) {
        .cf-dialog--xxl { max-width:100%; }
        .h-screen, .mybodyheight200px, .mybodyheight300px, .mybodyheight400px, .mybodyheight500px {
            height: 100%!important;
        }
        .tablearea { max-height: 100%; }
    }

    @media print {
        .no-print { display: none !important; }
    }

/* Charte cf-/ds- : boutons d'action de ligne (remplace dropdown Preline) */
.cf-actions { display:inline-flex; align-items:center; gap:4px; }
.cf-iconbtn { height:2rem; width:2rem; display:inline-flex; align-items:center; justify-content:center; border:none; border-radius:var(--cf-radius-sm); cursor:pointer; font-size:1rem; transition:all 0.15s; background:var(--cf-surface-alt); color:var(--cf-muted); }
.cf-iconbtn--primary:hover { background:rgb(var(--primary) / 0.12); color:rgb(var(--primary)); }
.cf-iconbtn--success:hover { background:rgb(var(--success) / 0.12); color:rgb(var(--success)); }
.cf-iconbtn--danger:hover { background:rgb(var(--danger) / 0.12); color:rgb(var(--danger)); }
</style>
